import { MapV2ModalLayoutMobile } from 'components/mapV2/MapV2Modal/layout/generic/MapV2ModalLayoutMobile';
import { MapV2ModalDetail } from 'components/mapV2/MapV2Modal/MapV2ModalDetail';
import { MapV2ModalList } from 'components/mapV2/MapV2Modal/MapV2ModalList';
import { AnimatePresence, motion, useAnimationControls } from 'framer-motion';
import { FFullMoment } from 'graphql/fragment/__generated__/FFullMoment';
import { WorldMapMarkerStory_worldMapView_markers } from 'graphql/query/__generated__/WorldMapMarkerStory';
import { useContext, useEffect, useState } from 'react';
import { CtxModal } from 'session/ctxModal';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    storiesList: FFullMoment[];
    marker: WorldMapMarkerStory_worldMapView_markers | null;
}

export const MapV2WithListMobile = (props: Props): JSX.Element => {
    const ctxModal = useContext(CtxModal);
    const [height, setHeight] = useState<string>('0px');

    const controls = useAnimationControls();

    useEffect(() => {
        if (ctxModal.detailModal?.detail) {
            controls.start({ x: -window.innerWidth }, { duration: 0.3, ease: 'easeInOut' });
        } else {
            controls.start({ x: 0 }, { duration: 0.3, ease: 'easeInOut' });
        }
    }, [ctxModal.detailModal?.detail]);

    const content = (
        <AnimatePresence mode="wait">
            <S_Over
                initial={{ x: 0 }}
                animate={controls}
                exit={{ x: 0 }}
                transition={{ duration: 0.0, ease: 'easeInOut' }}
                layout
            >
                <S_MapV2ModalList stories={props.storiesList} height={height} />
                {ctxModal.detailModal?.detail && (
                    <S_MapV2ModalDetail
                        story={ctxModal.detailModal.detail}
                        marker={props.marker}
                        height={height}
                    />
                )}
            </S_Over>
        </AnimatePresence>
    );

    return (
        <MapV2ModalLayoutMobile
            className={props.className}
            onMaxSnapSizeChanged={(height) => {
                setHeight(height);
            }}
        >
            {content}
        </MapV2ModalLayoutMobile>
    );
};

const S_Over = styled(motion.div)`
    display: flex;
    flex-direction: row;
    width: 200vw;
`;

const S_MapV2ModalDetail = styled(MapV2ModalDetail)`
    width: 100vw;
`;

const S_MapV2ModalList = styled(MapV2ModalList)`
    width: 100vw;
`;
